import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { WebStat } from '@mirohq-internal/stats-analytics';
var eventHub; //eslint-disable-next-line @typescript-eslint/no-var-requires

var analyticsLib = require('@mirohq-internal/stats-analytics/package.json');

var params = {
  apiHost: "".concat(process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_ENDPOINT, "/v1"),
  apiKey: process.env.NEXT_PUBLIC_ANALYTICS_EVENTHUB_AUTH,
  library: analyticsLib.name,
  version: analyticsLib.version
};

var getEventHub = function getEventHub() {
  // skip server side imports
  if (false) {
    return null;
  }

  if (!eventHub) {
    eventHub = getEventMethods(WebStat.createStatHandler({
      apiHost: params.apiHost,
      library: params.library,
      version: params.version,
      addCommonStatParams: function addCommonStatParams(params) {
        return _objectSpread({}, params);
      },
      // eslint-disable-next-line no-console
      sendError: function sendError(err, extra) {
        return window.console.error(err, extra);
      }
    }), // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    params);

    if (!window['analytics']) {
      window['analytics'] = eventHub;
    }
  }

  return eventHub;
};

function getEventMethods(handler, params) {
  return {
    identify: function identify(id) {
      WebStat.identify(handler, params.apiKey, {
        id: id,
        name: '',
        email: ''
      });
    },
    page: function page() {
      WebStat.page(handler, params.apiKey);
    },
    track: function track(eventName, properties) {
      WebStat.track(handler, params.apiKey, eventName, properties);
    }
  };
}

export default getEventHub();